import React, { useContext } from "react";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import ErrorHandler from "../components/errors/ErrorHandler";
import Home from "../pages/Home";
import PersonalData from "../pages/PersonalData";
import ActivityLogs from "../pages/PersonalData/ActivityLogs";
import ActiveDevices from "../pages/PersonalData/ActiveDevices";
import ApplicationAccess from "../pages/PersonalData/ApplicationAccess";
import LogoutComplete from "../pages/LogoutComplete";
import Consent from "../pages/Consent";
import PageNotFound from "../components/PageNotFound";
import Layout from "../components/Layout"; 
import { AuthContext } from "../contexts/AuthContext";
import { projectBasename } from "../constants";
import { getAuthRedirectUrl } from "../utils";

const Router = () => {
  const { AuthContextState } = useContext(AuthContext);
  const { isAuthenticated, isAuthLoading } = AuthContextState;
  const language = window.location.pathname.split("/")[1] || "en";
  const authRedirectUrl = getAuthRedirectUrl(language);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {/* Root Layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/:lang/logout-complete" element={<LogoutComplete />} />
          <Route
            path="/:lang/consent"
            element={
              <ProtectedRoute isAuth={isAuthenticated} isLoading={isAuthLoading} redirectPath={authRedirectUrl}>
                <Consent />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/personal_data"
            element={
              <ProtectedRoute isAuth={isAuthenticated} isLoading={isAuthLoading} redirectPath={authRedirectUrl}>
                <PersonalData />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/personal_data/activity_logs"
            element={
              <ProtectedRoute isAuth={isAuthenticated} isLoading={isAuthLoading} redirectPath={authRedirectUrl}>
                <ActivityLogs />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/personal_data/active_devices"
            element={
              <ProtectedRoute isAuth={isAuthenticated} isLoading={isAuthLoading} redirectPath={authRedirectUrl}>
                <ActiveDevices />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/personal_data/application_access"
            element={
              <ProtectedRoute isAuth={isAuthenticated} isLoading={isAuthLoading} redirectPath={authRedirectUrl}>
                <ApplicationAccess />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
        </Route>

        {/* Page Not Found */}
        <Route path="*" element={<PageNotFound />} />
      </>
    ),
    { basename: projectBasename }
  );

  return <RouterProvider router={router} />;
};

export default Router;
